import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const AuthContainer = styled.div`
  min-height: calc(100vh - 52px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const AuthCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.colors.cardShadow};
  padding: 40px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  max-width: 420px;
  width: 100%;

  @media (max-width: 720px) {
    padding: 30px 20px;
  }

  h1 {
    text-align: center;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 2rem;
  }

  p {
    text-align: center;
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: 32px;
    font-size: 0.95rem;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const ButtonContainer = styled.div`
  margin-top: 8px;

  button {
    width: 100%;
    min-height: 50px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 12px;
    cursor: pointer;
    border: none;
    background-color: ${({ theme }) => (theme.mode === 'dark' ? '#6366f1' : theme.colors.primary)};
    color: #ffffff;
    box-shadow: ${({ theme }) =>
      theme.mode === 'dark' ? '0 4px 16px rgba(99, 102, 241, 0.3)' : '0 4px 12px rgba(0, 0, 0, 0.1)'};
    transition:
      background-color 0.3s ease,
      transform 0.2s ease,
      box-shadow 0.3s ease;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => (theme.mode === 'dark' ? '#7c3aed' : theme.colors.primaryHover)};
      transform: translateY(-2px);
      box-shadow: ${({ theme }) =>
        theme.mode === 'dark' ? '0 6px 20px rgba(124, 58, 237, 0.4)' : '0 6px 16px rgba(0, 0, 0, 0.15)'};
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      background-color: ${({ theme }) =>
        theme.mode === 'dark' ? theme.colors.surfaceMuted : theme.colors.surfaceElevated};
      color: ${({ theme }) => theme.colors.textSecondary};
      border: 2px solid ${({ theme }) => theme.colors.border};
      cursor: not-allowed;
      box-shadow: none;
      opacity: ${({ theme }) => (theme.mode === 'dark' ? 0.7 : 0.6)};
      transform: none;
    }
  }
`

export const LinksContainer = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`

export const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#7c3aed' : theme.colors.primaryHover)};
    text-decoration: underline;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colors.border};
  margin: 24px 0 16px;
`

export const SignupText = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 0.9rem;
  margin: 0;
`

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`

export const Label = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`

export const StyledInput = styled.input`
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border: 2px solid
    ${({ theme, $hasError, $isValid }) => ($hasError ? '#ef4444' : $isValid ? '#10b981' : theme.colors.inputBorder)};
  border-radius: 10px;
  outline: none;
  color: ${({ theme }) => theme.colors.textPrimary};
  background: ${({ theme }) => theme.colors.inputBackground};
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
    opacity: 0.6;
  }

  &:focus {
    border-color: ${({ theme, $hasError }) => ($hasError ? '#ef4444' : theme.colors.primary)};
    box-shadow: 0 0 0 3px
      ${({ theme, $hasError }) => ($hasError ? 'rgba(239, 68, 68, 0.1)' : `${theme.colors.primary}20`)};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.surfaceMuted};
  }
`

export const ErrorText = styled.span`
  color: #ef4444;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: -4px;
`
